<template>
  <div :class="className" ref="lang" :style="{ height: height, width: width }" />
</template>
<script>
import echarts from "echarts";
export default {
  props: {
      className: {
          type: String,
          default: "chart",
      },
      width: {
          type: String,
          default: "100%",
      },
      height: {
          type: String,
          default: "100%",
      },
      chartData: {
          type: Object,
          default: ()=>{}
      },
  },
  data() {
      return {
          chart: null,
      };
  },
  watch: {
      chartData() {
        this.$nextTick(() => {
            this.initChart();
        });
      }
  },
  mounted() {
      this.$nextTick(() => {
          this.initChart();
      });
  },
  beforeDestroy() {
      if (!this.chart) {
          return;
      }
      this.chart.dispose();
      this.chart = null;
  },
  methods: {
      observe() {
        //   const observer = new ResizeObserver(entries => {
        //       this.chart&&this.chart.resize()
        //   })
        //   observer.observe(this.$el)
      },
      initChart() {
        let data=this.chartData.value
          let option = {
                title:[{
                    text:this.chartData.name,
                    x: 'center',
                    y: '70',
                    textStyle: {
                        color:'#00FDFF',
                        fontSize:16
                    }
                   
                },{
                    text:data.toFixed(2)+'%',
                    x: 'center',
                    y: 'center',
                    textStyle: {
                        color:'#E3FFFF',
                        fontSize:20
                    }
                   
                }],
                // 极坐标系
                polar: {
                    radius: ['80%', '100%'],
                    center: ['50%', '60%'],
                },
                // 极坐标系：角度轴
                angleAxis: {
                    max: 300,
                    min:100,
                    show: false,
                    type: 'value',
                    startAngle: 0,
                    endAngle: 180
                },
                // 极坐标系：径向轴
                radiusAxis: {
                    type: 'category',                    
                    show: true,
                    axisLabel: {
                        show: false,
                    },
                    axisLine: {
                        show: false,

                    },
                    axisTick: {
                        show: false
                    },
                },
                series: [
                    // 第二层：数据以进度条的形式展示
                    {
                        type: 'bar',
                        data: [{
                            value: data
                        }],
                        itemStyle: {
                            color: new echarts.graphic.LinearGradient(
                                0, 0, 1, 0, [{
                                        offset: 0,
                                        color: 'rgba(188, 255, 243, 0.1)'
                                    },
                                    {
                                        offset: 1,
                                        color: 'rgba(188, 255, 243, 1)'
                                    }
                                ]
                            )
                        },
                        barGap: '-100%',
                        coordinateSystem: 'polar',
                        roundCap: true,
                        cursor: 'auto',
                        z: 2,
                    },
                    // 第二层：进度条背景
                    {
                        type: 'bar',
                        data: [{
                            value: 100,
                        }],
                        itemStyle: {
                            color: '#205C6A',
                            borderWidth:5,
                            bordercolor:''
                        },
                        coordinateSystem: 'polar',
                        roundCap: false,
                        cursor: 'auto',
                        emphasis: {
                            itemStyle: {
                                color: '#205C6A'
                            }
                        },
                        z: 1
                    },
                ]
            };

          if(this.chart==null){
            this.chart = echarts.init(this.$el);
          }
          this.chart.off('click')
          this.chart.on('click', params => {
            if(params.componentType=='title'){
                this.$emit('toDetail')
            }
          })
          this.chart.setOption(option)
          this.observe()
      },
  },
};
</script>